import React, { useState, useEffect } from "react";
import { Box, Menu, Text, rem } from "@mantine/core";
import { ReactComponent as Ehr } from "../assets/img/Ehr.svg";
import { ReactComponent as Wear } from "../assets/img/Wear.svg";
import { ReactComponent as Arrow } from "../assets/img/Arrow.svg";
import { useNavigate } from "react-router-dom";
import arrowdown from "../assets/img/arrow multidirection.svg";

interface LabelMenuProps {
  onSelect: (value: string) => void;
}

const LabelMenu = ({ onSelect }: LabelMenuProps) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [dropdownWidth, setDropdownWidth] = useState("256px");

  const handleTypeSelect = (value: string) => {
    setSelectedType(value);
    setMenuOpen(false);
    onSelect(value);
  };

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <Menu opened={menuOpen} onClose={() => setMenuOpen(false)}>
        <Menu.Target>
          <div
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              width: "100%",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              color: "black",
              border: "none",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",

              flexDirection: "row",
            }}
          >
            <Text
              sx={{
                color: selectedType ? "#000" : "#999999",
                fontWeight: 500,
                marginTop: "10px",
                marginBottom: "14px",
                marginLeft: "14px",
              }}
            >
              {selectedType ? ` ${selectedType}` : "Select Type"}
            </Text>{" "}
            <Box sx={{ marginRight: "10px" }}>
              <img src={arrowdown} alt="" />
            </Box>
          </div>
        </Menu.Target>

        <Menu.Dropdown sx={{ width: "100% !important" }}>
          <MenuItemWithIcon
            icon={<Ehr />}
            text="Patient Standalone"
            onClick={() => handleTypeSelect("Patient Standalone")}
          />
          <Menu.Divider />
          <MenuItemWithIcon
            icon={<Ehr />}
            text="Practitioner Standalone"
            onClick={() => handleTypeSelect("Practitioner Standalone")}
          />
          <Menu.Divider />
          <MenuItemWithIcon
            icon={<Ehr />}
            text=" Backend System"
            onClick={() => handleTypeSelect("Backend System")}
          />
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
};

const MenuItemWithIcon = ({
  icon,
  text,
  onClick,
}: {
  icon: React.ReactNode;
  text: string;
  onClick: () => void;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Menu.Item
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "56px",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "0.5rem",
          marginLeft: "30px",
          flexWrap: "wrap",
          minWidth: "min-content",
        }}
      >
        {isHovered && icon}
        <span
          style={{
            fontSize: "14px",
            color: "#474E5B",
            fontWeight: 600,
            lineHeight: "21px",
            marginLeft: "16px",
          }}
        >
          {text}
        </span>
      </div>
    </Menu.Item>
  );
};

export default LabelMenu;
